import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { Touch } from 'vuetify/lib/directives';

Vue.use(Vuetify, {
  directives: {
    Touch
  }
});

const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    dark: false,
    options: {
      customProperties: true
    }
  },
  breakpoint: {
    thresholds: {
      sm: 768
    },
    mobileBreakpoint: 'sm'
  }
});

export default vuetify;
